<template>
  <el-container class="frequentDetial">
    <el-tabs class="tabs-box" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="信息" name="one">
        <div class="table-box">
          <h-table
            ref="tableRef"
            v-model:data="tableData"
            v-model:columns="columns"
            :method="facefrequencyAppearDetail"
            :params="params"
            @handleClick="handleClick"
            @select="hzTableSelect"
          >
            <template #partUrl="{ row }">
              <div class="table-role" @click="bigPicture(row.imageUrl)">
                <img v-if="row.imageUrl" :src="row.imageUrl" />
                <img v-else src="~@/assets/images/moren.png" />
              </div>
            </template>
            <template #passTime="{ row }">
              <span>
                {{ moment(row.snapTime).format("YYYY-MM-DD HH:mm:ss") }}
              </span>
            </template>
            <template #plateNo="{ row }">
              <div class="table-role">
                <h-car-plate
                  v-if="row.plateColor"
                  :type="row.plateColor"
                  :colorData="colorDict"
                  >{{ row.plateNo }}</h-car-plate
                >
              </div>
            </template>
          </h-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="统计" name="two">
        <facecountEchart
          v-if="activeName == 'two'"
          :params="params"
        ></facecountEchart>
      </el-tab-pane>
    </el-tabs>
  </el-container>
  <h-big-picture
    :pictureUrl="pictureUrl"
    v-model:visible="bigPictureVisible"
  ></h-big-picture>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  nextTick,
  watch,
} from "vue";
import {
  facefrequencyAppearDetail,
  facefrequencyAppearChart,
} from "@/api/publicSecurityResearch/keyCarPerson.js";
import facecountEchart from "./facecountEchart.vue";
import * as echarts from "echarts";
import moment from "moment";

// import _ from "lodash";
export default defineComponent({
  name: "frequentDetial",
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    colorDict: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { facecountEchart },
  setup(props) {
    const state = reactive({
      formVisible: false,
      columns: [
        { type: "selection", show: false },
        { type: "index" },
        {
          label: "抓拍图",
          slot: "partUrl",
        },
        {
          label: "姓名号",
          prop: "personName", // sex
        },
        {
          label: "身份证号",
          prop: "cardNumber", // sex
        },
        {
          label: "抓拍卡口",
          prop: "deviceName",
        },
        {
          label: "抓拍时间",
          slot: "passTime", // nation
        },
        // {
        //   label: "过车道",
        //   prop: "lane", // nation
        // },
      ],
      chartData: [],
      chartX: [],
      chartY: [],
      pictureUrl: null,
      bigPictureVisible: false,
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);
    const activeName = ref("one");
    watch(
      () => {
        props.params;
      },
      () => {
        nextTick(() => {
          activeName.value = "one";
          tableRef.value && tableRef.value.refresh();
        });
      },
      { deep: true, immediate: true }
    );

    const bigPicture = (url) => {
      console.log(url);
      state.pictureUrl = url;
      state.bigPictureVisible = true;
    };
    return {
      ...refData,
      facefrequencyAppearDetail,
      tableRef,
      formRef,
      activeName,
      bigPicture,
      moment,
    };
  },
});
</script>
<style lang="scss" scoped>
.frequentDetial {
  height: 60vh;
  width: 100%;
  .el-tabs {
    width: 100%;
    height: 100%;
  }
  .table-box {
    width: 100%;
    height: 100%;
    img {
      width: 114px;
      height: 67px;
    }
  }
  .el-tab-pane {
    width: 100%;
    height: 100%;
    #echartsTopLeft {
      width: 1000px;
      height: 500px;
    }
  }
  // #echartsTopLeft {
  //   width: 100%;
  //   height: 100%;
  // }
}
</style>
